import * as React from "react";
import { DataListAction, DataListCell, DataListItem, DataListItemCells, DataListItemRow } from "@patternfly/react-core";
import { Dropdown, DropdownItem, DropdownList, MenuToggle } from "@patternfly/react-core";
import { EllipsisVIcon, EyeIcon, TagIcon } from "@patternfly/react-icons";

export const DepartmentDataListItem = ({ department, isOpen, setIsOpen, onSelect, onToggle, onRead, onEdit, onDelete }) => {

  return (
    <DataListItem key={department.id} aria-labelledby={department.id}>
      <DataListItemRow>
        <DataListItemCells
          dataListCells={[
            <DataListCell key="icon" isFilled={false}>
              <TagIcon />
            </DataListCell>,
            <DataListCell key="name">
              <span id={department.id}>{department.name}</span>
            </DataListCell>
          ]}
        />
        <DataListAction isPlainButtonAction>
          <Dropdown
            popperProps={{ position: 'right' }}
            onOpenChange={(isOpen) => { if (isOpen) setIsOpen(department.id); else setIsOpen(0) }}
            onSelect={ onSelect }
            isOpen={(isOpen === department.id)}
            toggle={(toggleRef) => (
              <MenuToggle
                ref={toggleRef}
                isExpanded={isOpen === department.id}
                onClick={() => onToggle(department.id)}
                variant="plain"
                aria-label="Date List Item Action"
              >
                <EllipsisVIcon aria-hidden="true" />
              </MenuToggle>
            )}
          >
            <DropdownList>
              <DropdownItem key="view" icon={<EyeIcon />} onClick={() => onRead(department.id)}>View</DropdownItem>
            </DropdownList>
          </Dropdown>
        </DataListAction>
      </DataListItemRow>
    </DataListItem>
  );

};